module.exports = __webpack_public_path__ + "assets/img/home3-box3-img6.495f5a31.png";